import { FollowType } from "./enums";

export const isFollowType = (type: string): type is FollowType =>
  Object.values(FollowType)
    .map(type => type.toLowerCase())
    .includes(type.toLowerCase() as FollowType);

export const mapFollowType = (type: string) => {
  switch (type.toLowerCase()) {
    case "author":
      return FollowType.Author;
    case "section":
      return FollowType.Section;
    case "topic":
      return FollowType.Topic;
  }
};
